import { Moment } from 'moment';
import React, { FC } from 'react';

interface Props {
  time: Moment;
  from?: Moment;
  noSuffix?: boolean;
}

export const RelativeTime: FC<Props> = ({ time, from, noSuffix }) => (
  <>{from == null ? time.fromNow(!!noSuffix) : time.from(from, !noSuffix)}</>
);
